import { Divider, Segment } from "@simplybusiness/mobius";

import { HeaderItemRow } from "./HeaderItemRow";
import { PaymentItemRow } from "./PaymentItemRow";
import { SummaryItemRow } from "./SummaryItemRow";
import type { LabelValue, PaymentItem } from "./types";

export type PaymentItemsSectionProps = {
  /** Section title (e.g., "Today's payment", "Monthly payments") */
  headerText: string;
  /** Optional subtitle row (e.g., "First monthly payment taken: Feb 15") */
  headerItem?: LabelValue;
  /** List of payment line items */
  items: PaymentItem[];
  /** Optional summary rows shown below a divider */
  summaryItems?: LabelValue[];
  /** Hides headerItem when true (used for external carriers) */
  isExternalCarrier?: boolean;
  /** Whether this is a combined payment page (affects styling) */
  isCombined?: boolean;
};

export const PaymentItemsSection = ({
  headerText,
  headerItem,
  items,
  summaryItems,
  isExternalCarrier = false,
  isCombined = false,
}: PaymentItemsSectionProps) => {
  return (
    <Segment>
      <div className="mobius-payment-items-section__title">{headerText}</div>

      <div className="mobius-payment-items-section__grid">
        {headerItem && !isExternalCarrier && (
          <HeaderItemRow label={headerItem.label} value={headerItem.value} />
        )}
        {items.map((item, index) => (
          <PaymentItemRow key={index} labels={item.labels} value={item.value} />
        ))}
      </div>

      {summaryItems && summaryItems.length > 0 && (
        <>
          <Divider />
          {summaryItems.map((item, index) => (
            <SummaryItemRow
              key={index}
              label={item.label}
              value={item.value}
              isCombined={isCombined}
            />
          ))}
        </>
      )}
    </Segment>
  );
};

PaymentItemsSection.displayName = "PaymentItemsSection";
